const VIDEO_SOURCE_TYPES = ['.mp4', '.webm']

export const containsVideoSource = (sources: string[]): boolean =>
    sources.some((sources) =>
        VIDEO_SOURCE_TYPES.some((sourceType) => sources?.endsWith(sourceType))
    )
